import { combineReducers } from "redux";
import AuthReducer from "./auth/AuthReducer";
import BarClubReducer from "./barclub/BarClubReducer";
import CustomerReducer from "./customer/CustomerReducer";
import ProductReducer from "./products/ProductReducer";
import valueReducer from "./storeValues/StoreValuesReducer";
import WholesalerReducer from "./wholesaler/WholesalerReducer";
import BrandReducer from "./brands/BrandReducer";
import ProductQuantityReducer from "./productQuantity/ProductQuantityReducer";
import WholesalerProductReducer from "./wholesalerProduct/WholesalerProductReducer";
import TypeOfAlcoholReducer from "./typeOfAlcohol/TypeOfAlcoholReducer";
import consumptionReducer from "./reports/ReportReducer";
import CustomerAddressReducer from "./customerAddress/customerAddressReducer";
import CustomerReportReducer from "./customerReport/CustomerReportReducer";
import BarReportReducer from "./barReport/BarReportReducer";
import WholesalerProductReducerById from "./wholesalerReportById/WholesalerReportByIdReducer"

const rootReducer = combineReducers({
  auth: AuthReducer,
  product: ProductReducer,
  wholesaler: WholesalerReducer,
  barClub: BarClubReducer,
  values: valueReducer,
  customer: CustomerReducer,
  brand: BrandReducer,
  productQuantity: ProductQuantityReducer,
  wholesalerProduct: WholesalerProductReducer,
  TypeAlcohol: TypeOfAlcoholReducer,
  consumption: consumptionReducer,
  customerAddress: CustomerAddressReducer,
  barReport: BarReportReducer,
  customerReport: CustomerReportReducer,
  WholesalerReportById: WholesalerProductReducerById,
});

export default rootReducer;
